import { ComponentProps } from "react";

import { forwardRef, IconButton } from "@chakra-ui/react";

import { FiTrash2 } from "react-icons/fi";

import { Confirmation } from "@/components/common/controls/Confirmation";
import { generateTestId } from "@/util/testIds";

export type EntityDeleteButtonProps = Omit<
  ComponentProps<typeof IconButton>,
  "aria-label" | "icon"
> & {
  onConfirm: () => void;
  size?: "sm" | "md" | "lg";
  iconColor?: string;
  bg?: string;
  hoverBg?: string;
  marginRight?: string;
};

export const EntityDeleteButton = forwardRef<EntityDeleteButtonProps, "button">(
  (
    {
      onConfirm,
      size = "sm",
      iconColor = "white",
      bg,
      hoverBg,
      marginRight,
      ...buttonProps
    },
    ref
  ) => (
    <Confirmation
      onConfirm={onConfirm}
      trigger={
        <IconButton
          ref={ref}
          aria-label="Delete"
          size={size}
          icon={<FiTrash2 color={iconColor} />}
          bg={bg}
          _hover={{ bg: hoverBg }}
          mr={marginRight}
          data-testid={generateTestId.button("delete", "entity")}
          {...buttonProps}
        />
      }
      data-testid={generateTestId.section("delete-confirmation")}
    />
  )
);
